function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoTtamayoHorizontal = function SvgLogoTtamayoHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.68 57.24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 11.65H44.22v4.4h10.75v29.6h4.92v-29.6h10.6v29.6h4.91v-29.6H86zM96.09 11.6 83.8 45.65h5L91.48 38h16.08l2.71 7.63h5L103 11.6ZM93 33.66l6.51-18.48L106 33.66ZM137.15 33.56l-9.48-21.96h-7.88v34.05h4.81V16.51l9.42 21.61h6.1l9.42-21.61v29.14h4.81V11.6h-7.83zM171.14 11.6l-12.29 34.05h5l2.69-7.65h16.07l2.72 7.63h5l-12.29-34Zm-3.07 22.06 6.5-18.48 6.51 18.48ZM200.79 27.73l-8.81-16.13h-5.48l11.83 20.68v13.37h4.91V32.18l11.78-20.58h-5.48zM232.58 10.93c-10.24 0-17.2 8.25-17.2 17.87s6.6 17.51 17.2 17.51c10.19 0 17.1-7.88 17.1-17.51s-6.68-17.87-17.1-17.87m0 30.88c-7.83 0-12.13-6.2-12.13-13s4.3-13.41 12.13-13.41 12 6.7 12 13.41-4.27 13-12 13",
    style: {
      fill: "#001937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35.38v57.24H0z",
    style: {
      fill: "#3232c8"
    }
  }))));
};
export default SvgLogoTtamayoHorizontal;